<template>
	<section class="deep-register-view">
		<link rel="stylesheet" href="https://use.typekit.net/rhi6acd.css" />
		<div class="powered-by-logo"></div>
		<div class="deep-register-parts" v-if="institution">
			<div class="deep-register-half deep-register-emotion">
				<div class="register-images">
					<img class="cover" @error="downgradeImage" :src="image" />
					<img class="logo" :src="institution.logo_url" />
				</div>
				<h1>THANK YOU.</h1>
				<p>
					Your donation allows us to
					{{ institution.full_impact_statement }}. Please expect an
					email confirmation shortly.
				</p>

				<p>
					<span :style="{ fontSize: '24px', fontWeight: 'bold' }"
						>Did you know
					</span>
					that RoundUp App, allows you to round up debit and credit
					card transactions, giving the spare change to
					{{ institution.name }}? Click the link below to get a link
					to finish your account setup.
				</p>
				<div :style="{ display: 'flex', alignItems: 'center' }">
					<ui-button
						@click="navigate({ name: 'mindonation' }, forward)"
						:style="{ margin: 'auto' }"
					>
						Finish Account Setup
					</ui-button>
				</div>
			</div>
			<div class="deep-register-half deep-register-steps">
				<h2>How Does It Work?</h2>
				<div class="step">
					<img src="../../assets/deeplink_step2.svg" />
					<h3><small>1.</small> Create Your Account</h3>
					<p>
						Just fill in your name, email address and a password of
						your choosing and you’re all set.
					</p>
				</div>
				<div class="step">
					<img src="../../assets/deeplink_step1.svg" />
					<h3><small>2.</small> Link Your Cards and Bank</h3>
					<p>
						Connect your credit or debit cards to the app and
						securely authorize RoundUps with your bank.
					</p>
				</div>
				<div class="step">
					<img src="../../assets/deeplink_step3.svg" />
					<h3><small>3.</small> Make an Impact</h3>
					<p>
						The extra change from each transaction you make will be
						"rounded up" and donated every month to
						{{ institution.name }}.
					</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import UiButton from '../../ui/Button'
// import UiInput from '../../ui/Input'

export default {
	name: 'reset-password',
	components: { UiButton },
	props: {
		uuid: String
	},
	data() {
		return {
			isLoading: false,
			password: '',
			institution: {},
			noInstitution: false
		}
	},
	computed: {
		title() {
			if (!this.institution) {
				return false
			}
			return (
				'Support ' + this.institution.name + ' By Donating Your Change'
			)
		},
		description() {
			if (!this.institution) {
				return false
			}
			return (
				'Round up and donate your change to support ' +
				this.institution.name +
				'! Sign up in seconds to donate the change from your credit/debit card purchases so ' +
				this.institution.name +
				' can ' +
				this.institution.full_impact_statement +
				'.'
			)
		},
		image() {
			if (!this.institution) {
				return false
			}
			return this.appendToFilename(this.institution.image_url, '@2x')
		}
	},
	methods: {
		...mapActions(['getInstitution', 'forgotPassword']),
		...mapState({
			me: ({ me }) => me.current
		}),
		appendToFilename(filename = '', string) {
			var dotIndex = filename.lastIndexOf('.')
			if (dotIndex === -1) return filename + string
			else
				return (
					filename.substring(0, dotIndex) +
					string +
					filename.substring(dotIndex)
				)
		},
		downgradeImage(el) {
			el.srcElement.src = this.institution.image_url
		},
		setPassword() {
			this.forgotPassword(this.me.email)
		}
	},
	mounted() {
		this.getInstitution(this.uuid)
			.then((institution) => {
				this.institution = institution
				this.noInstitution = false
			})
			.catch(() => {
				this.noInstitution = true
			})
	}
}
</script>

<style lang="scss">
.deep-register-view {
	width: 960px;
	left: -240px;
	margin-top: 20px;
	text-align: left;
	position: absolute;
	@media screen and (max-width: 960px) {
		width: 100%;
		left: 0px;
	}
	h1 {
		font-family: ff-tisa-web-pro, sans-serif;
		font-size: 42px;
		font-weight: 500;
		line-height: 48px;
		color: #111;
		margin: 15px 0px 10px;
	}
	h2 {
		font-family: ff-tisa-web-pro, sans-serif;
		font-size: 36px;
		font-weight: 500;
		line-height: 48px;
		color: #111;
		margin: 10px 0px;
	}
	h3 {
		font-family: objektiv-mk3, sans-serif;
		font-size: 22px;
		font-weight: 600;
		color: #111;
		margin: 10px 0px 0px;
	}
	p {
		font-family: objektiv-mk3, sans-serif;
		font-size: 18px;
		font-weight: 400;
		color: #111;
	}
	.powered-by-logo {
		background: url('../../assets/roundup_logo.svg');
		background-size: 100% auto;
		height: 15px;
		width: 150px;
		position: relative;
		margin-bottom: 10px;
		@media screen and (max-width: 480px) {
			display: none;
		}
	}
	.deep-register-parts {
		display: flex;
		@media screen and (max-width: 960px) {
			display: block;
		}
	}
	.register-images {
		position: relative;
		margin-left: -40px;
		margin-right: -40px;
		margin-top: -30px;
		height: 275px;
		overflow: hidden;
		.cover {
			height: 100%;
			max-width: 100%;
			-o-object-fit: cover;
			object-fit: cover;
			width: 100%;
		}
		img {
			border-radius: 10px 10px 0px 0px;
			width: 100%;
			@media screen and (max-width: 480px) {
				border-radius: 0px;
			}
		}
		.logo {
			max-width: 75px;
			position: absolute;
			left: 40px;
			bottom: 15px;
			border-radius: 10px;
		}
	}
	.donate {
		color: #fff;
		position: relative;
		overflow: hidden;
		flex-direction: row;
		display: flex;
		width: 100%;
		min-height: 250px;
		.section {
			&.active {
				display: block;
				width: 100%;
			}
			&.inactive {
				display: none;
			}
		}
	}
	.deep-register-half {
		padding: 0px 15px;
	}
	.deep-register-emotion {
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
		padding: 30px 40px;
		width: 60%;
		flex-shrink: 0;
		@media screen and (max-width: 960px) {
			width: auto;
		}
		@media screen and (max-width: 480px) {
			border-radius: 0px;
		}
		.register-form {
			label {
				display: block;
				margin-top: 5px;
				margin-bottom: 5px;
			}
			.terms {
				font-size: 14px;
				color: #888;
				margin-bottom: 0px;
			}
			.stripe-card {
				width: 300px;
				border: 1px solid #808080;
				background: $input-grey;
				border-width: 0px;
				width: 100%;
				font-size: $font-size;
				padding: 20px 15px;
				outline: none;
				-webkit-appearance: none;
				appearance: none;
				border-radius: 10px;
				&.complete {
					border-color: #008000;
				}
				&::placeholder {
					color: $medium-grey;
				}
			}
		}
	}
	.deep-register-steps {
		padding: 30px 10px 30px 30px;
		@media screen and (max-width: 480px) {
			padding: 30px;
		}
		.step {
			vertical-align: top;
			padding: 10px 0px;
			.columns {
				display: flex;
			}
			p {
				margin-top: 5px;
			}
			img {
				width: 25%;
				height: 25%;
			}
		}
	}
	.roundup-button {
		width: auto;
		background: #184fd5;
		color: #fff;
		border-radius: 20px;
		cursor: pointer;
		display: inline-block;
		font-family: objektiv-mk3, sans-serif;
		font-size: 14px;
		font-weight: 600;
		padding: 10px 20px;
		margin-top: 20px;
		position: relative;
		text-decoration: none;
	}
}
</style>
